import * as types from "./mutation-types";

export const snapshotEvent = ({ commit, dispatch }, payload) => {
  return new Promise((resolve) => {
    let body = { data: JSON.parse(JSON.stringify(payload)) };
    // console.log("body", body);
    if (!body.data[0].status) {
      body.data.forEach((item) => {
        item.event = "NEW_POSITION";
        item.account_id = parseInt(item.account_id);
        item.investment_id = parseInt(item.investment_id);
        item.avg = item.avg ? parseFloat(item.avg) : 0;
        item.sl = item.sl ? parseFloat(item.sl) : 0;
        item.tp = item.tp ? parseFloat(item.tp) : 0;
        item.volume = item.volume ? parseFloat(item.volume) : 0;
      });
      commit(types.SAVE_EVENT, body);

      dispatch("investment/updateByInvestmentId_SnapshotEvent", payload, {
        root: true,
      }).then((response) => {
        resolve();
      });
    } else {
      if (body.data[0].status == "snapshot_warning") {
        // if (window.location.host == "localhost:8080")
        //   console.log(
        //     "%c%s",
        //     "font-weight:bold;color:crism;",
        //     body.data[0].msg
        //   );
      }
      resolve();
    }
  });
};

export const saveEvent = ({ commit }, payload) =>
  new Promise((resolve, reject) => {
    let statusOk = false;
    // if (payload.data.length == 0) {
    //   reject({
    //     type: "UNDEFINED",
    //     message: "Não é possível salvar evento de um array vazio.",
    //     status: false,
    //   });
    // }
    // +--------------------------------------------------------------------------+
    // | NEW_POSITION, UPDATE_POSITION                                            |
    // +--------------------------------------------------------------------------+
    if (Array.isArray(payload.data) && payload.data[0].hasOwnProperty("event")) {
      // Pegando o tipo de evento retornado.
      let eventName = payload.data[0].event;

      let allowedEvents = [
        "VERTICAL_LINE",
        "HORIZONTAL_LINE",
        "MARK",
        "MASK_GAIN",
        "MASK_LOSS",
        "MASK_TIME",
        "MASK_LIMIT",
        "MASK_TP",
        "MASK_SL",
        "MASK_RP",
        "MASK_BE",
        "MASK_POSITION_OPEN",
        "NEW_ORDER",
        "UPDATE_ORDER",
        "ORDER_CLOSE",
        "NEW_POSITION",
        "UPDATE_POSITION",
        "EXTERNAL_ACTION",
      ];
      if (allowedEvents.includes(eventName)) {
        commit(types.SAVE_EVENT, payload);
        statusOk = true;
      }

      if (eventName == "POSITION_CLOSE") {
        commit(types.CLOSE_POSITION, payload);
        // let body = {
        //   accountType: rootState.accountTypes.selectedAccount.account_type,
        //   investmentId: Number(payload.data[0].investment_id),
        // };
        statusOk = true;
      }

      if (statusOk) {
        resolve({
          type: eventName,
          message: `Evento '${eventName}' salvo com sucesso!`,
          status: true,
        });
      } else {
        reject({
          type: null,
          message: "Houve um problema inesperado!",
          status: false,
        });
      }
    } else if (!Array.isArray(payload.data)) {
      if (payload.data.notif_type) {
        let eventName = payload.data.notif_type;

        commit(types.SAVE_EVENT, payload);
        statusOk = true;
        if (statusOk) {
          resolve({
            type: eventName,
            message: `Evento '${eventName}' salvo com sucesso!`,
            status: true,
          });
        } else {
          reject({
            type: null,
            message: "Houve um problema inesperado!",
            status: false,
          });
        }
      } else {
        let eventName = payload.data.event;
        commit(types.SAVE_EVENT, payload);
        resolve({
          type: eventName,
          message: `Evento '${eventName}' salvo com sucesso!`,
          status: true,
        });
      }
    }
  });

export const cleanEvent = ({ commit }, payload) => {
  commit(types.CLEAN_EVENT, payload);
};

export const cleanAllEvent = ({ commit }) => {
  commit(types.CLEAN_ALL_EVENT);
};

/**
 * Exclui objeto de NEW_POSITION com investment_id = payload.
 * @param {*} payload investment_id
 */
export const cleanEventByInvestmentId = ({ commit }, payload) => {
  commit(types.CLEAN_EVENT_BY_INVESTMENT_ID, payload);
};

export const saveNotification = ({ commit }, payload) => {
  commit(types.SAVE_NOTIFICATION, payload);
};
